/* tslint:disable: jsx-no-lambda*/
import * as React from 'react';
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { __, __r } from 'react-i18n/lib';
import { Link } from 'react-router';
import {
  LoginButton,
  Header,
  NoAccountWrapper,
  Register,
  Wrapper,
} from '../General/Auth';
import { CheckBox } from '../General/Checkbox';
import { FlexRowCenterVertical } from '../../Defaults/Flexbox/Flexbox';

interface Props {
  isEndUser: boolean;
  setIsEndUser: (isEndUser: boolean) => void;
  redirectToForm: () => void;
}

function PreRegisterForm(props: Props) {
  const { isEndUser, setIsEndUser, redirectToForm } = props;
  return (
    <Wrapper>
      <Header>{`${__('Registrácia')}`}</Header>
      <CheckboxWrapper>
        <CheckBox
          wrapperStyle={{ marginBottom: rem(24), marginRight: rem(0) }}
          label={__('Som koncový zákazník')}
          type={'checkbox'}
          onClick={() => setIsEndUser(true)}
          name="onlyAvailable"
          rounded={true}
          selected={isEndUser}
        />
        <CheckBox
          wrapperStyle={{ marginBottom: rem(8), marginRight: rem(0) }}
          label={__('Chcem sa stať veľkoobchodným partnerom')}
          type={'checkbox'}
          onClick={() => setIsEndUser(false)}
          name="onlyAvailable"
          rounded={true}
          selected={!isEndUser}
        />
      </CheckboxWrapper>
      <LoginButton type="submit" onClick={redirectToForm}>
        {`${__('Pokračovať')}`}
      </LoginButton>
      <NoAccountWrapper>
        {`${__('Máte u nás účet')}? `}
        <Link to={__r('routes:prihlasenie', '/prihlasenie')}>
          <Register>{__('Prihláste sa')}</Register>
        </Link>
      </NoAccountWrapper>
    </Wrapper>
  );
}

const CheckboxWrapper = styled(FlexRowCenterVertical)`
  margin-left: 0;
  flex-flow: row wrap;

  ${({ theme }) => theme.mediab.m760`
    display: block;
    flex-flow: column;
    margin: 0;
    padding: ${rem(24)} ${rem(16)} ${rem(12)};
    align-items: flex-start;
  `}
`;

export { PreRegisterForm };
